import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/Footer";
import Header from "../../../Components/Header/Header";
import "../AdminDashboard/AdminDashboard.css";
import { AiFillDelete } from "react-icons/ai";
import { PiUsersFourDuotone } from "react-icons/pi";
import { Modal, Box, Button, Switch } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { MdMonetizationOn } from "react-icons/md";
import { APIUrl, APIUrlToken, getIsUser } from "../../../Utils/Utils";
import Loader from "../../../Components/Loader/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [openEnableButton, setOpenEnableButton] = useState(false);
  const [allUsers, setAllUsers] = useState([]);

  const [allTransactions, setAllTransactions] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [skip, setSkip] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState("");
  const [athleteRole, setAthleteRole] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [playerFilter, setPlayerFilter] = useState("");
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [players, setPlayers] = useState([]);
  const [userId, setUserId] = useState();
  const handleCancelAthleteModal = () => {
    setSelectedPlayer(null);
    setAthleteRole(false);
    setPlayerFilter("");
  };
  const filteredPlayers = players
    .filter((player) =>
      player.player_name.toLowerCase().includes(playerFilter.toLowerCase())
    )
    .filter((p) => p.player_espn_id !== selectedPlayer?.player_espn_id);

  const handleRemoveAccount = () => {
    const url = `${APIUrl()}/v1/local/auth/users/${open?.user_id}`;
    const option = {
      method: "DELETE",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };
    axios(option)
      .then((response) => {
        toast.success("User account has been successfully removed.");
        setOpen("");
        getAllUsers(true);
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  const getAllUsers = (isFirst) => {
    setLoading(true);
    const url = `${APIUrl()}/v1/all-users?limit=10&skip=${isFirst ? 0 : skip}`;
    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.data || [];
        if (isFirst) {
          setAllUsers(data);
          setSkip(0);
        } else {
          setAllUsers([...allUsers, ...data]);
        }
        setUserCount(response?.data?.count);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  const getAllTransactions = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/get_all_transactions`;
    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data || [];
        setAllTransactions(data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  useEffect(() => {
    if (skip > 0) {
      getAllUsers();
    }
  }, [skip]);
  useEffect(() => {
    getAllUsers();
    getAllTransactions();
  }, []);

  const handleOpenAthelete = (id) => {
    setAthleteRole(true);
    setUserId(id);
  };

  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (playerFilter.trim().length >= 3) {
        handleFilterData();
      } else {
        setPlayers([]);
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [playerFilter]);

  const handleFilterData = () => {
    setLoading(true);
    const url = `https://api.nil-collab.com/v1/common_search_?query=${playerFilter.trim()}&page=1&limit=100`;
    axios
      .post(
        url,
        {},
        {
          headers: {
            accept: "application/json",
            "X-API-Key": "ghp_ms5ZAl9kdZI9MaylrnlICQYPiaukG84E4kMlll",
          },
        }
      )
      .then((response) => {
        setPlayers(response?.data?.players || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching players:", error);
        setLoading(false);
      });
  };

  const handleSubmit = async () => {
    const url = `${APIUrl()}/v1/assign_player_id_to_user`;

    const payload = {
      user_id: userId,
      player_id: selectedPlayer?.player_espn_id,
    };

    try {
      setLoading(true);

      const response = await axios.post(url, payload, {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
      });

      toast.success("Player assigned successfully!");
      setAthleteRole(false);
      setSelectedPlayer(null);
      setAthleteRole(false);
      setPlayerFilter("");
    } catch (error) {
      console.error("Error assigning player:", error);
      toast.error("Failed to assign player!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? <Loader /> : null}
      <Header />
      <div className="page-main-container-aboutus">
        <div className="heading-button">
          <div className="tophead-head">
            <div className="user-trans-admin">
              <h2
                className={
                  activeTab === 1
                    ? "icons-all-list-mmbr-new"
                    : "icons-all-list-mmbr"
                }
                onClick={() => setActiveTab(1)}
              >
                <span className="icon-admin">
                  <PiUsersFourDuotone />
                  All Users List
                </span>
              </h2>
              <h2
                className={
                  activeTab === 2
                    ? "icons-all-list-mmbr-new"
                    : "icons-all-list-mmbr"
                }
                onClick={() => setActiveTab(2)}
              >
                <span className="icon-admin">
                  <MdMonetizationOn />
                  All Transactions
                </span>
              </h2>
            </div>
          </div>
          {activeTab === 1 ? (
            <div className="dataTables_scrollBody">
              {allUsers?.length ? (
                <>
                  <table
                    id="table_id"
                    className="table table-striped dataTable no-footer user_table_nil"
                  >
                    <thead className="table-head-ad-dash-playesinfo">
                      <tr>
                        <th
                          className="sorting sorting_asc"
                          aria-sort="ascending"
                        >
                          S.No
                        </th>
                        <th className="sorting">Name</th>
                        <th className="sorting">Email</th>
                        <th className="sorting">Username</th>
                        <th className="sorting">Mobile</th>
                        <th className="sorting">Company Name</th>
                        <th className="sorting">Address</th>
                        <th className="sorting">City</th>
                        <th className="sorting">State</th>
                        <th className="sorting">Country</th>
                        <th className="sorting">Created Date</th>
                        <th className="sorting">Role</th>
                        <th className="sorting">Action</th>
                      </tr>
                    </thead>
                    <tbody className="table-body-ad-dash-playesinfo">
                      {allUsers?.map((item, index) => (
                        <tr>
                          <td className="sorting_1">{index + 1}</td>
                          <td>
                            {item?.first_name ? item?.first_name : "-"}{" "}
                            {item?.last_name}
                          </td>
                          <td>{item?.user_email ? item?.user_email : "-"}</td>
                          <td>{item?.user_name ? item?.user_name : "-"}</td>
                          <td>
                            {item?.phone_number ? item?.phone_number : "-"}
                          </td>
                          <td>
                            {item?.company_name ? item?.company_name : "-"}
                          </td>
                          <td>{item?.address ? item?.address : "-"}</td>
                          <td>{item?.city ? item?.city : "-"}</td>
                          <td>{item?.state ? item?.state : "-"}</td>
                          <td>{item?.country ? item?.country : "-"}</td>
                          <td>
                            {item?.user_created_at
                              ? moment(item?.user_created_at).format(
                                  "MM/DD/YYYY"
                                )
                              : "-"}
                          </td>
                          <td>
                            {" "}
                            {item?.user_role === "athlete" ? (
                              <button className="submit-modal-card-assigned">
                                Change Role
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  handleOpenAthelete(item?.user_id)
                                }
                                className="submit-modal-card"
                              >
                                Change Role
                              </button>
                            )}
                          </td>
                          <td style={{ cursor: "pointer" }}>
                            <AiFillDelete
                              onClick={() => {
                                setOpen(item);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="prev-next-container">
                    {userCount === allUsers?.length ? null : (
                      <p
                        className="next-btn-dash"
                        onClick={() => setSkip((prev) => prev + 10)}
                      >
                        Load More
                      </p>
                    )}
                  </div>
                </>
              ) : (
                <div className="no_results">No Results found.</div>
              )}
            </div>
          ) : activeTab === 2 ? (
            <div className="dataTables_scrollBody">
              {allTransactions?.length ? (
                <table
                  id="table_id"
                  className="table table-striped dataTable no-footer user_table_nil"
                >
                  <thead className="table-head-ad-dash-playesinfo">
                    <tr>
                      <th className="sorting sorting_asc" aria-sort="ascending">
                        S.No
                      </th>
                      <th className="sorting">User Email</th>
                      <th className="sorting">Company Name</th>
                      <th className="sorting">Conference Name</th>
                      <th className="sorting">Team Name</th>
                      <th className="sorting">Player Name</th>
                      <th className="sorting">Transaction Id</th>
                      <th className="sorting">Transaction Amount</th>
                      <th className="sorting">Transaction Type</th>
                      <th className="sorting">Recurring Duration</th>
                      <th className="sorting">Service Type</th>
                      <th className="sorting">Transaction Date</th>
                    </tr>
                  </thead>
                  <tbody className="table-body-ad-dash-playesinfo">
                    {allTransactions?.map((item, index) => (
                      <tr>
                        <td className="sorting_1">{index + 1}</td>
                        <td>{item?.user_email ? item?.user_email : "-"}</td>
                        <td>
                          {item?.user_company_name
                            ? item?.user_company_name
                            : "-"}
                        </td>
                        <td>
                          {item?.team_conference ? item?.team_conference : "-"}
                        </td>
                        <td>{item?.team_name ? item?.team_name : "-"}</td>
                        <td>{item?.player_name}</td>
                        <td>{item?.transaction_id}</td>
                        <td>{item?.transaction_amount}</td>
                        <td>
                          {item?.transaction_type
                            ? item?.transaction_type
                            : "-"}
                        </td>
                        <td>
                          {item?.recurring_cost_duration > 0
                            ? `${item?.recurring_cost_duration} months`
                            : "-"}
                        </td>
                        <td>{item?.nil_service_type ?? "-"}</td>
                        <td>
                          {item?.created_at
                            ? moment(item?.created_at).format("MM/DD/YYYY")
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="no_results">No Results found.</div>
              )}
            </div>
          ) : null}
        </div>
        <Modal open={open?.user_id} onClose={() => setOpen("")}>
          <div className="modal-container">
            <Box
              sx={{
                width: 400,
                p: 3,
                bgcolor: "white",
                borderRadius: 2,
                position: "relative",
              }}
            >
              <IoClose
                className="close-icon"
                size={24}
                onClick={() => setOpen("")}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  cursor: "pointer",
                }}
              />
              <h3 className="removemodl-admin">
                Are you sure you want to remove this user's account?
              </h3>

              <div className="buttons-cards-modal">
                <Button
                  className="submit-modal-card"
                  onClick={handleRemoveAccount}
                >
                  Submit
                </Button>
                <Button
                  className="cancel-button-modal"
                  onClick={() => setOpen("")}
                >
                  Cancel
                </Button>
              </div>
            </Box>
          </div>
        </Modal>

        <Modal
          open={openEnableButton}
          onClose={() => setOpenEnableButton(false)}
        >
          <div className="modal-container">
            <Box
              sx={{
                width: 400,
                p: 3,
                bgcolor: "white",
                borderRadius: 2,
                position: "relative",
                height: "auto",
              }}
            >
              <IoClose
                className="close-icon"
                size={24}
                onClick={() => setOpenEnableButton(false)}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  cursor: "pointer",
                }}
              />
              <h3>
                Are you sure you want to {isEnabled ? "Disable" : "Enable"}{" "}
                Donate Request?
              </h3>
              <div
                className="buttons-cards-modal"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <span>{isEnabled ? "Enabled" : "Disabled"}</span>
                <Switch
                  checked={isEnabled}
                  onChange={handleToggle}
                  color="primary"
                />
              </div>
            </Box>
          </div>
        </Modal>

        <Modal open={athleteRole} onClose={() => setAthleteRole(false)}>
          <div className="modal-container">
            <Box
              sx={{
                width: 600,
                height: 500,
                p: 3,
                bgcolor: "white",
                borderRadius: 2,
                position: "relative",
                boxShadow: 24,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <IoClose
                size={24}
                onClick={() => handleCancelAthleteModal()}
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  cursor: "pointer",
                }}
              />

              <h3 style={{ marginBottom: "20px", textAlign: "center" }}>
                Assign Athlete Role
              </h3>

              <input
                type="search"
                placeholder="Search player..."
                value={playerFilter}
                onChange={(e) => setPlayerFilter(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  marginBottom: "15px",
                }}
              />

              {selectedPlayer && (
                <div
                  style={{
                    border: "2px solid red",
                    borderRadius: "8px",
                    padding: "10px 15px",
                    marginBottom: "10px",
                    backgroundColor: "#ffeaea",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <strong style={{ color: "red" }}>
                      {selectedPlayer.player_name}
                    </strong>{" "}
                    — {selectedPlayer.team_name}
                  </div>
                  <IoClose
                    size={20}
                    color="red"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedPlayer(null)}
                    title="Remove Selection"
                  />
                </div>
              )}

              {/* Player List */}
              <div
                style={{
                  flex: 1,
                  overflowY: "auto",
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  padding: "5px 0",
                }}
              >
                {loading && <p style={{ textAlign: "center" }}>Loading...</p>}

                {!loading && filteredPlayers.length > 0 && (
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    {filteredPlayers.map((player, index) => (
                      <li
                        key={index}
                        style={{
                          padding: "10px 12px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                          transition: "0.2s ease",
                        }}
                        onClick={() => setSelectedPlayer(player)}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f9f9f9")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "white")
                        }
                      >
                        <strong>{player.player_name}</strong> —{" "}
                        {player.team_name}
                      </li>
                    ))}
                  </ul>
                )}

                {!loading &&
                  playerFilter.trim().length >= 3 &&
                  filteredPlayers.length === 0 && (
                    <p style={{ textAlign: "center", color: "#777" }}>
                      No players found
                    </p>
                  )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => handleCancelAthleteModal()}
                  sx={{
                    borderColor: "#ccc",
                    color: "#555",
                    borderRadius: "8px",
                    textTransform: "none",
                    px: 3,
                  }}
                >
                  Cancel
                </Button>

                <Button
                  onClick={() => {
                    if (selectedPlayer) handleSubmit(selectedPlayer);
                  }}
                  disabled={!selectedPlayer}
                  className="submit-modal-card"
                >
                  Change Role
                </Button>
              </div>
            </Box>
          </div>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};
export default AdminDashboard;
